import React from 'react';
import styled from 'styled-components';

import Layout from '@/layout';

import Hero from './components/Hero';
import Navigation from './components/Navigation';
import BenefitItems from './components/BenefitItems';
import Services from './components/Services';
import Form from './components/Form';

function ServiceBenefits() {
  return (
    <Layout>
      <Component>
        <Hero />
        <Navigation />
        <BenefitItems />
        <Services />
        <Form />
      </Component>
    </Layout>
  );
}

export default ServiceBenefits;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
